"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3431],{

/***/ 65125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var Badge = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("border-radius:8px;min-width:16px;height:16px;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.red60 */ .O9.red60, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";font-size:11px;line-height:1;padding:0 2px;display:flex;align-items:center;justify-content:center;"),
        className: props.className,
        children: props.children
    });
};


/***/ }),

/***/ 96747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ClickableIcomoonIcon; },
/* harmony export */   "g": function() { return /* binding */ IcomoonIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




var IcomoonIcon = function(_param) {
    var name = _param.name, className = _param.className, label = _param.label, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "name",
        "className",
        "label"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("i", {
        className: "icon-".concat(name, " ").concat(className),
        "aria-label": label,
        "data-appcues": rest["data-appcues"],
        "data-test-id": rest["data-test-id"]
    });
};
var ClickableIcomoonIcon = function(_param) {
    var name = _param.name, className = _param.className, onClick = _param.onClick, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "name",
        "className",
        "onClick"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        onClick: onClick,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(IcomoonIcon, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            name: name,
            className: className
        }, rest))
    });
};


/***/ }),

/***/ 41691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Overlay; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);


var Overlay = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("position:relative;width:fit-content;line-height:0;"),
        children: [
            props.children,
            props.show ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("position:absolute;", typeof props.top === "number" ? "top: ".concat(props.top, "px;") : null, " ", typeof props.right === "number" ? "right: ".concat(props.right, "px;") : null, " ", typeof props.bottom === "number" ? "bottom: ".concat(props.bottom, "px;") : null, " ", typeof props.left === "number" ? "left: ".concat(props.left, "px;") : null),
                children: props.overlay
            }) : null
        ]
    });
};


/***/ }),

/***/ 99129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vq": function() { return /* binding */ FacebookIcon; },
/* harmony export */   "Zm": function() { return /* binding */ TwitterIcon; },
/* harmony export */   "pA": function() { return /* binding */ LinkedinIcon; }
/* harmony export */ });
/* unused harmony export NewspicksIcon */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96747);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);





var TwitterIcon = function(param) {
    var className = param.className, size = param.size, color = param.color, _active = param.active, active = _active === void 0 ? false : _active;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__/* .IcomoonIcon */ .g, {
        name: "x",
        className: className,
        label: "X",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:", size || 26, "px !important;color:", active ? plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.twitter */ .O9.twitter : color ? color : "#ddd", ";")
    });
};
var FacebookIcon = function(param) {
    var className = param.className, size = param.size, color = param.color, _active = param.active, active = _active === void 0 ? false : _active;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__/* .IcomoonIcon */ .g, {
        name: "facebook",
        className: className,
        label: "Facebook",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:", size || 26, "px !important;color:", active ? plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.facebook */ .O9.facebook : color ? color : "#ddd", ";")
    });
};
var NewspicksIcon = function(param) {
    var className = param.className, size = param.size, color = param.color, _active = param.active, active = _active === void 0 ? false : _active;
    return /*#__PURE__*/ _jsx(IcomoonIcon, {
        name: "newspicks",
        className: className,
        css: /*#__PURE__*/ css("font-size:", size || 26, "px !important;color:", active ? colors.facebook : color ? color : "#ddd", ";")
    });
};
var LinkedinIcon = function(param) {
    var className = param.className, size = param.size, color = param.color, _active = param.active, active = _active === void 0 ? false : _active;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__/* .IcomoonIcon */ .g, {
        name: "linkedin-square-fill",
        className: className,
        label: "LinkedIn",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:", size || 26, "px !important;color:", active ? plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.facebook */ .O9.facebook : color ? color : "#ddd", ";")
    });
};


/***/ }),

/***/ 92123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ToolbarButton; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);


var ToolbarButton = function(props) {
    var show = typeof props.show === "boolean" ? props.show : true;
    return show ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        onClick: props.onClick,
        onMouseOver: props.onMouseOver,
        onMouseLeave: props.onMouseLeave,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("cursor:pointer;&:hover{opacity:0.75;}"),
        className: props.className,
        children: props.children
    }) : null;
};


/***/ }),

/***/ 26123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48261);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Logo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80774);
/* harmony import */ var _SNS__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47599);
/* harmony import */ var _lib_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73650);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18584);










var Footer = function(props) {
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_7__/* .useUser */ .a)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("footer", {
        id: "footer",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black20 */ .O9.black20, ";display:flex;flex-direction:column;align-items:center;", props.noBorder ? "" : "border-top: 1px solid ".concat(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";"), "        color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";"),
        className: props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("display:flex;flex-direction:column;row-gap:24px;width:calc(100% - 48px);max-width:1120px;padding-block:40px 0;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{column-gap:40px;flex-direction:row;justify-content:space-between;width:calc(100% - 40px);padding-block:48px 40px;}"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("flex-shrink:0;display:flex;flex-direction:column;align-items:center;row-gap:16px;"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("p", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin:0;"),
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: "/",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_Logo__WEBPACK_IMPORTED_MODULE_4__/* .MonochromeLogo */ .cX, {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_SNS__WEBPACK_IMPORTED_MODULE_5__/* .SNS */ ._, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("nav", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("display:flex;flex-direction:column;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{flex-direction:row;flex-wrap:wrap;gap:64px min(4vw,64px);}"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(FooterMenu, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuTitle, {
                                        children: "Speedaについて"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .enterpriseUrl */ .t8,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "Speedaとは"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .customerInterviewsUrl */ .pD,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "導入事例"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .seminarsUrl */ .to,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "セミナー・イベント"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .resourcesUrl */ .li,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "資料・レポート"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .downloadDocumentUrl */ .Qf,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "資料ダウンロード"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .trialRequestUrl */ .d1,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "無料トライアル"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(FooterMenu, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuTitle, {
                                        children: "プロダクト"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .speedaBusinessInsightsTopUrl */ .T0,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "経済情報リサーチ"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "/",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                children: "スタートアップ情報リサーチ"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .speedaInnovationInsightsTopUrl */ .Jv,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "イノベーション情報リサーチ"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .speedaRandDInsightsTopUrl */ .Be,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "R&D分析"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .speedaCustomerAnalyticsTopUrl */ .ug,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "顧客企業分析"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(FooterMenu, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuTitle, {
                                        children: "サポート"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "https://help.initial.inc/",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: "ヘルプセンター"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "https://help.initial.inc/ja/articles/11374241",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "イベント"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FooterMenuLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "/contact",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                children: "お問い合わせ"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("ul", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin:0;padding:0;display:flex;justify-content:center;flex-direction:row;gap:16px min(12vw,40px);padding-block:24px;border-top:1px solid #363636;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{justify-content:normal;flex-direction:column;border:0;padding-block:0;}"),
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(OperatingCompanyLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .operatingCompanyUrl */ .V8,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "運営会社"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(OperatingCompanyLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .operatingCompanyInformationUrl */ .oq,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "お知らせ"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(OperatingCompanyLink, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .operatingCompanyCareersUrl */ .IH,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                                target: "_blank",
                                                children: "採用情報"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("display:flex;justify-content:center;width:calc(100% - 40px);border-top:1px solid #363636;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("display:flex;align-items:center;justify-content:space-between;flex-direction:column;row-gap:24px;width:100%;max-width:1120px;padding-block:24px 40px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{flex-direction:row;padding-block:16px 32px;column-gap:32px;}"),
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("ul", {
                            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin:0;padding:0;display:flex;flex-wrap:wrap;justify-content:center;column-gap:16px;row-gap:8px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{justify-content:normal;column-gap:24px;}"),
                            "data-testid": "footer-bottom-links",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(OptionLink, {
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: (0,_lib_user__WEBPACK_IMPORTED_MODULE_6__/* .isLatestEnterpriseOrTrial */ .Fo)(user) ? _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .touSpeedaUrl */ .uZ : _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .touGuestPath */ .ZF,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                            children: "利用規約"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(OptionLink, {
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .privacyPolicyUrl */ .wo,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                            children: "個人情報保護方針"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(OptionLink, {
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .extModulesUrl */ .np,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                            children: "利用者に関する情報の外部送信について"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("p", {
                            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin:0;flex-shrink:0;"),
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("small", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("color:#cbcbcb;font-size:12px;line-height:1.25;letter-spacing:0.02em;"),
                                children: "\xa9 Uzabase, Inc."
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var FooterMenu = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("dl", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin:0;display:flex;flex-direction:column;row-gap:16px;border-top:1px solid #363636;padding-block:24px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{border:0;padding-block:0;}"),
        className: props.className,
        children: props.children
    });
};
var FooterMenuTitle = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("dt", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";font-size:14px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.bold */ .LZ.weight.bold, ";line-height:1.5;letter-spacing:0.02em;"),
        children: props.children
    });
};
var FooterMenuLink = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("dd", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin:0;a{color:#cbcbcb;font-size:14px;line-height:1.25;letter-spacing:0.02em;&:hover{text-decoration:underline;}}"),
        children: props.children
    });
};
var OperatingCompanyLink = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("li", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("a{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.textInvert */ .O9.textInvert, ";font-size:14px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.bold */ .LZ.weight.bold, ";line-height:1.25;letter-spacing:0.02em;}"),
        children: props.children
    });
};
var OptionLink = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("li", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("a{color:#cbcbcb;font-size:12px;line-height:1.25;letter-spacing:0.02em;&:hover{text-decoration:underline;}}"),
        children: props.children
    });
};


/***/ }),

/***/ 91897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ OrganizationLogo; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./lib/organization.ts
var tokenToType = {
    companies: "company",
    investors: "investor",
    venture_supports: "venture-support",
    people: "person"
};
var organizationTypeFromPath = function(path) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "company";
    var token = path.split("/").filter(function(t) {
        return t;
    })[0];
    var type = tokenToType[token];
    if (!type) {
        type = fallback;
    }
    return type;
};
var typeToPath = {
    company: "/static/images/default/company.png",
    investor: "/static/images/default/investor.png",
    "venture-support": "/static/images/default/venture_support.png",
    person: "/static/images/default/person.png"
};
var organizationDefaultImagePath = function(type) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "company";
    var path = typeToPath[type];
    if (!path) {
        path = typeToPath[fallback];
    }
    return path;
};

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./components/common/OrganizationLogo.tsx





var OrganizationLogo = function(props) {
    var url = props.item.imageUrl;
    if (!url) {
        url = organizationDefaultImagePath(organizationTypeFromPath(props.item.path));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(props._css),
        name: props.item.title,
        src: url
    });
};


/***/ }),

/***/ 47599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ SNS; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var _atoms_SocialIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99129);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);





var SNS = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("ul", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin:0;padding:0;display:flex;column-gap:8px;li{a{display:flex;align-items:center;justify-content:center;width:36px;aspect-ratio:1 / 1;:hover{text-decoration:none;opacity:0.8;}}}"),
        className: props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("li", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                    href: "https://twitter.com/speeda_ub",
                    target: "_blank",
                    "data-testid": "twitter",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_atoms_SocialIcon__WEBPACK_IMPORTED_MODULE_1__/* .TwitterIcon */ .Zm, {
                        size: 24,
                        color: plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00
                    })
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("li", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                    href: "https://www.facebook.com/ub.speeda",
                    target: "_blank",
                    "data-testid": "facebook",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_atoms_SocialIcon__WEBPACK_IMPORTED_MODULE_1__/* .FacebookIcon */ .Vq, {
                        size: 24,
                        color: plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00
                    })
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("li", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                    href: "https://www.linkedin.com/showcase/speeda/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_atoms_SocialIcon__WEBPACK_IMPORTED_MODULE_1__/* .LinkedinIcon */ .pA, {
                        size: 24,
                        color: plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 33431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Template; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40872);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _header_AppBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22991);
/* harmony import */ var _header_AppBarForMobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10785);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26123);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18584);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4807);









var Template = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _param);
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_4__/* .useUser */ .a)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("header", {
                "data-testid": "global-navigation",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_5__.mq.untilMedium, "{display:none;}"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_header_AppBar__WEBPACK_IMPORTED_MODULE_1__/* .AppBar */ .xG, {
                            user: user
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_5__.mq.large, "{display:none;}"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_header_AppBarForMobile__WEBPACK_IMPORTED_MODULE_2__/* .AppBarForMobile */ .xP, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("main", {
                className: props.className,
                children: props.children
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Footer__WEBPACK_IMPORTED_MODULE_3__/* .Footer */ .$, {})
        ]
    });
};


/***/ }),

/***/ 22991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sU": function() { return /* binding */ APPBAR_HEIGHT; },
  "xG": function() { return /* binding */ AppBar; }
});

// UNUSED EXPORTS: ENTERPRISE_DETAIL_BUTTON_WIDTH, GLOBAL_MENU_BUTTON_WIDTH, LOGIN_BUTTON_WIDTH, MODERATOR_ICON_WIDTH, NOTIF_ICON_WIDTH, USER_ICON_WIDTH, USER_MENU_WIDTH

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 3 modules
var Transition = __webpack_require__(26273);
// EXTERNAL MODULE: ./components/atoms/IcomoonIcon.tsx
var IcomoonIcon = __webpack_require__(96747);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/browser.ts
var browser = __webpack_require__(38387);
// EXTERNAL MODULE: ./lib/api/suggestion.ts
var suggestion = __webpack_require__(82031);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./lib/url.ts
var url = __webpack_require__(48261);
;// CONCATENATED MODULE: ./components/header/molucule/SuggestItem.tsx






var ITEM_HEIGHT = 32;
var createPathBaseOnType = function(item) {
    switch(item.type){
        case "tag":
            return "".concat((0,url/* newTagPath */.w6)(item), "?from=suggest");
        case "domestic-company":
            return companyPath(item.shortname);
        case "domestic-investor":
            return investorPath(item.shortname);
        case "overseas-company":
            return companyPath(item.globalId);
        case "overseas-investor":
            return investorPath(item.globalId);
    }
};
var SuggestItem = function(param) {
    var item = param.item, children = param.children;
    var as = createPathBaseOnType(item);
    switch(item.type){
        case "tag":
            return children("#".concat(item.name), {
                href: url/* TAG_HREF */.cS,
                type: item.type,
                as: as,
                icon: "tag"
            });
        case "domestic-company":
            return children(item.name, {
                href: url/* COMPANY_HREF */.bP,
                type: item.type,
                as: as,
                icon: "startup"
            });
        case "domestic-investor":
            return children(item.name, {
                href: url/* INVESTOR_HREF */.JM,
                type: item.type,
                as: as,
                icon: "investor"
            });
        case "overseas-company":
            return children(item.name, {
                href: url/* COMPANY_HREF */.bP,
                type: item.type,
                as: as,
                icon: "startup"
            });
        case "overseas-investor":
            return children(item.name, {
                href: url/* INVESTOR_HREF */.JM,
                type: item.type,
                as: as,
                icon: "investor"
            });
    }
};
var SuggestItemLink = function(param) {
    var as = param.as, href = param.href, type = param.type, icon = param.icon, highlight = param.highlight, children = param.children, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;font-size:14px;"),
        className: "suggest-item ".concat(type ? "suggest-item-".concat(type) : null),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.text */.O9.text, ";display:flex;align-items:center;width:100%;height:", ITEM_HEIGHT, "px;background-color:", highlight ? dist/* colors.gray40 */.O9.gray40 : dist/* colors.white00 */.O9.white00, ";cursor:pointer;&:hover,&:focus{background-color:", dist/* colors.gray40 */.O9.gray40, ";}transition:background-color 0.14s linear;"),
            onClick: function() {
                onClick({
                    href: href,
                    as: as
                });
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                    name: icon,
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:18px;color:", dist/* colors.gray60 */.O9.gray60, ";display:inline-block;padding:0 8px 0 16px;")
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;width:100%;padding-right:16px;strong{color:", dist/* colors.black10 */.O9.black10, ";font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";}"),
                    children: children
                })
            ]
        })
    });
};
var companyPath = function(shortname) {
    return "/companies/".concat(shortname, "?from=suggest");
};
var investorPath = function(shortname) {
    return "/investors/".concat(shortname, "?from=suggest");
};

;// CONCATENATED MODULE: ./lib/highlight.ts
// NOTE: Doesn't support half-katakana
var toHiragana = function(text) {
    return text.replace(/[\u30a1-\u30f6]/g, function(match) {
        var chr = match.charCodeAt(0) - 0x60;
        return String.fromCharCode(chr);
    });
};
var toKatakana = function(text) {
    return text.replace(/[\u3041-\u3096]/g, function(match) {
        var chr = match.charCodeAt(0) + 0x60;
        return String.fromCharCode(chr);
    });
};
// NOTE: Doesn't support multiple keywords delimited by spaces
var emphasize = function(text, keyword) {
    keyword = highlight_escape(keyword);
    var raw = "".concat(keyword, "|").concat(toHiragana(keyword), "|").concat(toKatakana(keyword));
    var pattern = new RegExp(raw, "gi");
    return text.replace(pattern, "<strong>$&</strong>");
};
// Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
var highlight_escape = function(pattern) {
    return pattern.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
};

;// CONCATENATED MODULE: ./components/header/molucule/SuggestList.tsx







var SuggestList = function(param) {
    var keyword = param.keyword, result = param.result, highlight = param.highlight, onSelect = param.onSelect;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&&&&{margin:0;padding:0;}"),
        children: result.map(function(item, i) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestItem, {
                item: item,
                children: function(content, props) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestItemLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        onClick: onSelect,
                        highlight: i === highlight
                    }, props), {
                        children: markup(content, keyword)
                    }));
                }
            }, i);
        })
    });
};
var markup = function(content, keyword) {
    var html = emphasize(content, keyword);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};

// EXTERNAL MODULE: ./components/header/molucule/CloseButton.tsx
var CloseButton = __webpack_require__(27092);
// EXTERNAL MODULE: ./lib/easings.ts
var easings = __webpack_require__(1252);
// EXTERNAL MODULE: ./lib/log.ts
var log = __webpack_require__(79240);
// EXTERNAL MODULE: ./hooks/useOnClickOutside.ts
var useOnClickOutside = __webpack_require__(24211);
;// CONCATENATED MODULE: ./components/header/molucule/GlobalSearchForm.tsx



















var GlobalSearchForm_ITEM_HEIGHT = 32;
var ESC_KEY = 27;
var UP_KEY = 38;
var DOWN_KEY = 40;
var MAX_ITEMS = 16;
var MAX_TAG_ITEMS = 8;
var MAX_DOMESTIC_COMPANIES = 6;
var MAX_OVERSEAS_COMPANIES = 6;
var MAX_DOMESTIC_INVESTORS = 6;
var MAX_OVERSEAS_INVESTORS = 6;
var initialKeyword = function() {
    if (!browser/* isBrowser */.jU || window.location.pathname === "search") {
        return "";
    }
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("q") || "";
};
var globalSearchPath = function(keyword) {
    return "/search?q=".concat((0,suggestion/* escapeKeyword */.Z)(keyword), "&from=suggest");
};
var GlobalSearchForm = function() {
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        router.events.on("routeChangeStart", clearSuggest);
        return function() {
            router.events.off("routeChangeStart", clearSuggest);
        };
    }, []);
    var ref = (0,react.useState)(initialKeyword()), keyword = ref[0], setKeyword = ref[1];
    var ref1 = (0,react.useState)(null), handle = ref1[0], setHandle = ref1[1];
    var ref2 = (0,react.useState)(0), req = ref2[0], setReq = ref2[1];
    var ref3 = (0,react.useState)("none"), loadingStatus = ref3[0], setLoadingStatus = ref3[1];
    (0,react.useEffect)(function() {
        if (handle) {
            clearTimeout(handle);
        }
        var newHandle = setTimeout(function() {
            setReq(new Date().getTime());
        }, 350);
        setHandle(newHandle);
    }, [
        keyword
    ]);
    var clearSuggest = function() {
        setShowSuggest(false);
        setKeyword("");
        setShowSuggest(false);
        setResult({
            tags: [],
            domesticCompanies: [],
            overseasCompanies: [],
            domesticInvestors: [],
            overseasInvestors: [],
            displayLength: 0
        });
        setLoadingStatus("none");
    };
    var ref4 = (0,react.useState)(false), showSuggest = ref4[0], setShowSuggest = ref4[1];
    var ref5 = (0,react.useState)(null), ctrl = ref5[0], setCtrl = ref5[1];
    var ref6 = (0,react.useState)({
        tags: [],
        domesticCompanies: [],
        overseasCompanies: [],
        domesticInvestors: [],
        overseasInvestors: [],
        displayLength: 0
    }), result = ref6[0], setResult = ref6[1];
    var ref7 = (0,react.useState)(null), highlight = ref7[0], setHighlight = ref7[1];
    (0,react.useEffect)(function() {
        var run = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var abort, data, suggestCandidateList, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (ctrl) {
                                ctrl.abort();
                            }
                            abort = new AbortController();
                            setCtrl(abort);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0,suggestion/* suggest */.D)(keyword, {
                                    signal: abort.signal
                                })
                            ];
                        case 2:
                            data = _state.sent();
                            suggestCandidateList = (0,_to_consumable_array/* default */.Z)(data.filter(function(item) {
                                return item.type === "tag";
                            }).slice(0, MAX_TAG_ITEMS)).concat((0,_to_consumable_array/* default */.Z)(data.filter(function(item) {
                                return item.type === "domestic-company";
                            }).slice(0, MAX_DOMESTIC_COMPANIES)), (0,_to_consumable_array/* default */.Z)(data.filter(function(item) {
                                return item.type === "domestic-investor";
                            }).slice(0, MAX_DOMESTIC_INVESTORS)), (0,_to_consumable_array/* default */.Z)(data.filter(function(item) {
                                return item.type === "overseas-company";
                            }).slice(0, MAX_OVERSEAS_COMPANIES)), (0,_to_consumable_array/* default */.Z)(data.filter(function(item) {
                                return item.type === "overseas-investor";
                            }).slice(0, MAX_OVERSEAS_INVESTORS))).slice(0, MAX_ITEMS);
                            setResult({
                                tags: suggestCandidateList.filter(function(item) {
                                    return item.type === "tag";
                                }),
                                domesticCompanies: suggestCandidateList.filter(function(item) {
                                    return item.type === "domestic-company";
                                }),
                                overseasCompanies: suggestCandidateList.filter(function(item) {
                                    return item.type === "overseas-company";
                                }),
                                domesticInvestors: suggestCandidateList.filter(function(item) {
                                    return item.type === "domestic-investor";
                                }),
                                overseasInvestors: suggestCandidateList.filter(function(item) {
                                    return item.type === "overseas-investor";
                                }),
                                displayLength: suggestCandidateList.length
                            });
                            setLoadingStatus("done");
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            (0,log/* printError */.O)(e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function run() {
                return _ref.apply(this, arguments);
            };
        }();
        var cancel = function() {
            if (ctrl) {
                ctrl.abort();
                setCtrl(null);
            }
            setShowSuggest(false);
            setResult({
                tags: [],
                domesticCompanies: [],
                overseasCompanies: [],
                domesticInvestors: [],
                overseasInvestors: [],
                displayLength: 0
            });
            setLoadingStatus("none");
        };
        if (keyword) {
            setLoadingStatus("loading");
            setShowSuggest(true);
            run();
        } else {
            cancel();
        }
    }, [
        req
    ]);
    var refGlobalSearch = (0,react.useRef)(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        refGlobalSearch
    ], function() {
        setShowSuggest(false);
    });
    var handleChange = function(e) {
        setShowSuggest(true);
        setKeyword(e.currentTarget.value);
    };
    var handleKeyDown = function(e) {
        if (e.keyCode === ESC_KEY) {
            setShowSuggest(false);
        }
    };
    var handleFormKeyDown = function(e) {
        if (result.displayLength === 0) {
            return; // 結果が返ってきてないときは無視する
        }
        switch(e.keyCode){
            case UP_KEY:
                if (highlight === null) {
                    setHighlight(result.displayLength - 1);
                } else {
                    if (highlight > 0) {
                        setHighlight(highlight - 1);
                    } else {
                        setHighlight(null);
                    }
                }
                break;
            case DOWN_KEY:
                if (highlight === null) {
                    setHighlight(0);
                } else {
                    if (highlight >= result.displayLength - 1) {
                        setHighlight(null);
                    } else {
                        setHighlight(highlight + 1);
                    }
                }
                break;
        }
    };
    var refInputField = (0,react.useRef)(null);
    var handleSubmit = function(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (highlight === null) {
            router.push(globalSearchPath(keyword));
        } else {
            var map = composeMapForHighlight(result);
            var item = map[highlight];
            router.push(item.itemPath);
        }
        if (refInputField.current) {
            refInputField.current.blur();
        }
        clearSuggest();
    };
    var handleClose = function() {
        clearSuggest();
        if (refInputField.current) {
            refInputField.current.focus();
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;top:calc(50% - 40px / 2);display:flex;align-items:flex-start;flex-grow:1;align-self:flex-start;padding:0 16px 0 0;"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            ref: refGlobalSearch,
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:337px;background:", dist/* colors.white00 */.O9.white00, ";border:1px solid ", dist/* colors.border */.O9.border, ";border-radius:20px;", showSuggest && "padding: 0 0 4px;", " ", showSuggest && "border-radius: 8px;", ":hover{box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);}:focus-within{box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);outline:-webkit-focus-ring-color auto 1px;border:2px solid;}"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
                    action: "/search",
                    method: "get",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:40px;transition:background-color 0.16s ", easings/* EASING_FAST */.i, ",box-shadow 0.19s linear 0.07s;box-sizing:border-box;"),
                    onSubmit: handleSubmit,
                    onKeyDown: handleFormKeyDown,
                    className: "global-search-form",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;height:100%;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                name: "search",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:20px;color:", dist/* colors.textLight */.O9.textLight, ";display:inline-block;margin-left:16px;transition:color 0.16s ", easings/* EASING_FAST */.i, ";&:has(+ input[name='keyword']:focus){color:", dist/* colors.cyan60 */.O9.cyan60, ";}")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                className: "search-input",
                                name: "keyword",
                                placeholder: "スタートアップ、投資家、タグなどを検索",
                                type: "text",
                                autoComplete: "off",
                                value: keyword,
                                ref: refInputField,
                                onChange: handleChange,
                                onKeyDown: handleKeyDown,
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.text */.O9.text, ";width:calc(100% - 50px);height:100%;border:none;padding:0 0 0 8px;background-color:transparent;outline:none;&::placeholder{color:", dist/* colors.textLight */.O9.textLight, ";font-size:14px;}")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Transition/* default */.ZP, {
                                in: keyword.length > 0,
                                timeout: {
                                    enter: 140,
                                    exit: 120
                                },
                                children: function(status) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseButton/* CloseButton */.P, {
                                        status: status,
                                        onClick: handleClose
                                    });
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Transition/* default */.ZP, {
                    in: true,
                    timeout: {
                        enter: 180,
                        exit: 160
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(transitionCss(result.displayLength, showSuggest), ";"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestResultList, {
                            loadingStatus: loadingStatus,
                            keyword: keyword,
                            handleSubmit: handleSubmit,
                            result: result,
                            highlight: highlight
                        })
                    })
                })
            ]
        })
    });
};
var order = [
    "tags",
    "domesticCompanies",
    "overseasCompanies",
    "domesticInvestors",
    "overseasInvestors", 
];
var composeMapForHighlight = function(result) {
    return order.map(function(kind) {
        return {
            kind: kind,
            result: result[kind]
        };
    }).reduce(function(acc, d) {
        var list = d.result.map(function(item, pos) {
            return {
                kind: d.kind,
                pos: pos,
                itemLabel: item.name,
                itemPath: createPathBaseOnType(item)
            };
        });
        return (0,_to_consumable_array/* default */.Z)(acc).concat((0,_to_consumable_array/* default */.Z)(list));
    }, []);
};
var SuggestResultList = function(props) {
    var result = props.result, keyword = props.keyword, loadingStatus = props.loadingStatus, highlight = props.highlight, handleSubmit = props.handleSubmit;
    var router = (0,next_router.useRouter)();
    var handleSelect = function(to) {
        router.push(to.href, to.as);
    };
    var himap = composeMapForHighlight(result);
    var hint = highlight !== null ? himap[highlight] : {
        kind: "",
        pos: 0,
        itemLabel: "",
        itemPath: ""
    };
    if (loadingStatus === "none") return null;
    if (loadingStatus === "loading") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestListWrapper, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;height:32px;justify-content:center;align-items:center;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                    version: "1.1",
                    id: "L4",
                    xmlns: "http://www.w3.org/2000/svg",
                    xmlnsXlink: "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    viewBox: "0 0 52 52",
                    "enable-background": "new 0 0 0 0",
                    xmlSpace: "preserve",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:block;width:25px;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                            fill: dist/* colors.gray60 */.O9.gray60,
                            stroke: "none",
                            cx: "6",
                            cy: "26",
                            r: "6",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("animate", {
                                attributeName: "opacity",
                                dur: "1.6s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                            fill: dist/* colors.gray60 */.O9.gray60,
                            stroke: "none",
                            cx: "26",
                            cy: "26",
                            r: "6",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("animate", {
                                attributeName: "opacity",
                                dur: "1.6s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.4"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                            fill: dist/* colors.gray60 */.O9.gray60,
                            stroke: "none",
                            cx: "46",
                            cy: "26",
                            r: "6",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("animate", {
                                attributeName: "opacity",
                                dur: "1.6s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.7"
                            })
                        })
                    ]
                })
            })
        }, "loading");
    }
    if (loadingStatus === "done" && result.displayLength === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestListWrapper, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                onMouseDown: handleSubmit,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.text */.O9.text, ";padding:7px 0 7px 44px;font-size:14px;cursor:pointer;background-color:", dist/* colors.white00 */.O9.white00, ";&:hover{background-color:", dist/* colors.gray40 */.O9.gray40, ";}"),
                children: "すべての検索結果を見る"
            })
        }, "notfound");
    }
    // kind, position
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            result.tags.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestListWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestList, {
                    keyword: keyword,
                    result: result.tags,
                    onSelect: handleSelect,
                    highlight: hint.kind === "tags" ? hint.pos : null
                })
            }, "tags"),
            (result.domesticCompanies.length > 0 || result.overseasCompanies.length > 0) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SuggestListWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestList, {
                        keyword: keyword,
                        result: result.domesticCompanies,
                        onSelect: handleSelect,
                        highlight: hint.kind === "domesticCompanies" ? hint.pos : null
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestList, {
                        keyword: keyword,
                        result: result.overseasCompanies,
                        onSelect: handleSelect,
                        highlight: hint.kind === "overseasCompanies" ? hint.pos : null
                    })
                ]
            }, "companies"),
            (result.domesticInvestors.length > 0 || result.overseasInvestors.length > 0) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SuggestListWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestList, {
                        keyword: keyword,
                        result: result.domesticInvestors,
                        onSelect: handleSelect,
                        highlight: hint.kind === "domesticInvestors" ? hint.pos : null
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestList, {
                        keyword: keyword,
                        result: result.overseasInvestors,
                        onSelect: handleSelect,
                        highlight: hint.kind === "overseasInvestors" ? hint.pos : null
                    })
                ]
            }, "investors")
        ]
    });
};
var transitionCss = function(count, show) {
    var height = count * GlobalSearchForm_ITEM_HEIGHT + (5 + 9 + 8);
    if (count === 0) {
        height += GlobalSearchForm_ITEM_HEIGHT;
    }
    if (show) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-height:", height, "px;opacity:1;transition:max-height 0.18s ", easings/* EASING_FAST */.i, ",opacity 0.16s ", easings/* EASING_SLOW */.r, ";");
    } else {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-height:0;overflow:hidden;opacity:0;transition:max-height 0.16s ", easings/* EASING_FAST */.i, ",opacity 0.14s ", easings/* EASING_SLOW */.r, ";");
    }
};
var SuggestListWrapper = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread/* default */.Z)({
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;padding:4px 0;::before{content:'';display:block;position:absolute;top:0;width:calc(100% - 16px * 2);height:0;margin-left:16px;border-top:1px solid ", dist/* colors.border */.O9.border, ";}")
    }, props));
};

// EXTERNAL MODULE: ./lib/user.ts
var lib_user = __webpack_require__(73650);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/header/molucule/GlobalNavigationTab.tsx






var GlobalNavigationTab = function(props) {
    var ref = (0,react.useState)(false), openTabMenu = ref[0], setOpenTabMenu = ref[1];
    var href = !props.children ? props.url : "#";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "global-navigation-tab",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;display:flex;"),
        onMouseOver: function() {
            return setOpenTabMenu(true);
        },
        onMouseLeave: function() {
            return setOpenTabMenu(false);
        },
        onClick: function() {
            if (props.onClickNavigationTab) {
                props.onClickNavigationTab();
            }
        },
        children: [
            props.children ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                "aria-expanded": openTabMenu,
                "aria-controls": props.slugName ? "global-nav-item-".concat(props.slugName) : undefined,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:inherit;height:48px;padding:15px 0;font-size:14px;line-height:125%;letter-spacing:0.02em;cursor:pointer;border:0;border-bottom:2px solid transparent;background-color:transparent;", props.isActive ? "border-bottom-color: ".concat(dist/* colors.black10 */.O9.black10, ";") : "&:hover {\n              border-bottom-color: ".concat(dist/* colors.gray50 */.O9.gray50, ";\n            }"), "            &:focus-visible{outline:-webkit-focus-ring-color auto 1px;}"),
                onClick: function() {
                    setOpenTabMenu(!openTabMenu);
                },
                children: [
                    props.tabName,
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:7px;padding-left:6px;position:relative;top:-1.5px;"),
                        name: "arrow1-down"
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: href,
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:inherit;height:48px;padding:15px 0;font-size:14px;line-height:125%;letter-spacing:0.02em;transition:none;text-decoration:none;", props.isActive ? "border-bottom: 2px solid ".concat(dist/* colors.black10 */.O9.black10, ";") : "&:hover {\n              border-bottom: 2px solid ".concat(dist/* colors.gray50 */.O9.gray50, ";\n            }"), "              &::after{position:absolute;top:0;right:0;bottom:0;left:0;content:'';}"),
                    children: props.tabName
                })
            }),
            openTabMenu && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                id: props.slugName ? "global-nav-item-".concat(props.slugName) : undefined,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;left:0;top:48px;background-color:", dist/* colors.white00 */.O9.white00, ";z-index:10;border-radius:8px;box-shadow:0px 0px 10px rgba(0,0,0,0.1);padding:8px 0;"),
                children: props.children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/header/molucule/TabMenuList.tsx


var TabMenuList = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0;margin:0;min-width:160px;white-space:nowrap;"),
        children: props.children
    });
};

;// CONCATENATED MODULE: ./components/header/molucule/TabMenuListItem.tsx





var TabMenuListItem = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&:hover{background-color:", dist/* colors.gray40 */.O9.gray40, ";}"),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: props.url,
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:inherit;text-decoration:none;transition:none;font-size:14px;line-height:1;letter-spacing:0.03em;display:flex;align-items:center;justify-content:space-between;column-gap:8px;min-height:40px;padding-block:8px;padding-inline:16px;"),
                    target: props.external ? "_blank" : undefined,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: props.itemName
                        }),
                        props.external && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.gray60 */.O9.gray60, ";font-size:16px;"),
                            name: "arrow-right-up"
                        })
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./lib/api/notification.ts
var notification = __webpack_require__(56473);
// EXTERNAL MODULE: ./components/header/molucule/ProfileImage.tsx
var ProfileImage = __webpack_require__(36287);
// EXTERNAL MODULE: ./contexts/AuthContext.ts
var AuthContext = __webpack_require__(18584);
;// CONCATENATED MODULE: ./components/header/molucule/Menu.tsx




var Menu = function(props) {
    var show = typeof props.show === "boolean" ? props.show : true;
    return show ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        id: props.id,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:fixed;right:24px;top:calc(", APPBAR_HEIGHT, " - 20px);background-color:", dist/* colors.white00 */.O9.white00, ";z-index:30;width:", props.width ? props.width : 368, "px;max-height:608px;border:solid 1px ", dist/* colors.gray50 */.O9.gray50, ";border-radius:8px;box-shadow:0px 0px 10px rgba(0,0,0,0.1);padding:8px 0;"),
        className: props.className,
        children: props.children
    }) : null;
};

;// CONCATENATED MODULE: ./components/header/molucule/ProfileMenuItem.tsx



var ProfileMenuItem = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: props.path,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-decoration:none;transition:none;font-size:14px;letter-spacing:0.02em;color:", dist/* colors.text */.O9.text, ";padding:12px 16px;height:38px;&:hover{background-color:", dist/* colors.backgroundGray */.O9.backgroundGray, ";}"),
            children: props.itemName
        })
    });
};

// EXTERNAL MODULE: ./lib/api/auth.ts
var auth = __webpack_require__(68203);
;// CONCATENATED MODULE: ./components/header/molucule/ProfileMenu.tsx










var ProfileMenu = function(props) {
    var user = (0,AuthContext/* useUser */.a)();
    var handleLogout = function() {
        (0,auth/* npidLogout */.BE)();
        (0,auth/* ssoLogout */.t$)();
        location.href = url/* logoutPath */.FK;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Menu, {
        width: 192,
        show: props.isOpen,
        id: "account-menu",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileMenuItem, {
                itemName: "アカウント設定",
                path: url/* myPagePath */.h$
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileMenuItem, {
                itemName: "フォローリスト",
                path: url/* followListPath */.K7
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileMenuItem, {
                itemName: "ダウンロード",
                path: url/* downloadHistoryPath */.fP
            }),
            (0,lib_user/* isLatestEnterpriseOrTrial */.Fo)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileMenuItem, {
                itemName: "ステータス設定",
                path: url/* statusSettingPath */.Uk
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:4px 0;")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-decoration:none;transition:none;font-size:14px;letter-spacing:0.02em;display:flex;flex-direction:row;align-items:center;color:", dist/* colors.text */.O9.text, ";padding:12px 16px;height:38px;&:hover{background-color:", dist/* colors.backgroundGray */.O9.backgroundGray, ";}"),
                href: "https://help.initial.inc/",
                target: "_blank",
                rel: "noopener noreferrer",
                children: "ヘルプ"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:4px 0;")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;text-align:left;background-color:transparent;border:none;cursor:pointer;outline:none;padding:0;appearance:none;font-size:14px;letter-spacing:0.02em;padding:12px 16px;height:38px;color:", dist/* colors.text */.O9.text, ";&:hover{background-color:", dist/* colors.backgroundGray */.O9.backgroundGray, ";}&:focus-visible{outline:-webkit-focus-ring-color auto 1px;}"),
                onClick: handleLogout,
                children: "ログアウト"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/header/molucule/ProfileButton.tsx





var ProfileButton = function(props) {
    var ref = (0,react.useState)(false), profileOpened = ref[0], setProfileOpened = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "header-user-icon",
        onMouseOver: function() {
            return setProfileOpened(true);
        },
        onMouseLeave: function() {
            return setProfileOpened(false);
        },
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;display:flex;max-width:32px;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                "aria-expanded": profileOpened,
                "aria-controls": "account-menu",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0;cursor:pointer;border:none;background-color:transparent;&:focus-visible{outline:-webkit-focus-ring-color auto 1px;}&:hover .circle{background:rgba(0,0,0,0.03);}"),
                onClick: function() {
                    return setProfileOpened(function(prev) {
                        return !prev;
                    });
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "circle",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:center;align-items:center;width:32px;height:32px;border-radius:50px;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileImage/* ProfileImage */.m, {
                        user: props.user
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileMenu, {
                isOpen: profileOpened
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/atoms/Badge.tsx
var Badge = __webpack_require__(65125);
// EXTERNAL MODULE: ./components/atoms/Overlay.tsx
var Overlay = __webpack_require__(41691);
// EXTERNAL MODULE: ./lib/date.ts + 4 modules
var date = __webpack_require__(57923);
;// CONCATENATED MODULE: ./lib/notifications.ts
var formatMessage = function(message) {
    if (message == null) return "";
    var formatMessage = message.replace(/https:.*$/, "").replace(/internal:.*$/, "");
    return formatMessage;
};

// EXTERNAL MODULE: ./components/common/OrganizationLogo.tsx + 1 modules
var OrganizationLogo = __webpack_require__(91897);
;// CONCATENATED MODULE: ./components/header/molucule/NotificationMenuItem.tsx






var NotificationMenuItem = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: props.item.path,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;padding:12px 16px;align-items:flex-start;border-bottom:1px solid ", dist/* colors.gray50 */.O9.gray50, ";width:368px;height:80px;gap:8px;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrganizationLogo/* OrganizationLogo */.o, {
                        item: props.item,
                        _css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:56px !important;height:56px !important;padding:0;")
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-items:flex-start;padding:0px;width:272px;height:54px;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "notification-body",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:272px;height:36px;font-size:12px;line-height:150%;letter-spacing:0.03em;color:", dist/* colors.text */.O9.text, ";"),
                            children: formatMessage(props.item.body)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:272px;height:18px;color:", dist/* colors.textLight */.O9.textLight, ";font-size:12px;line-height:150%;display:flex;align-items:center;letter-spacing:0.03em;"),
                            children: (0,date/* formatDate */.p6)(props.item.createdAt, "yyyy/MM/dd")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/header/molucule/NotificationMenu.tsx






var MAX_NOTIFICATION_COUNT = 7;
var NotificationMenu = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Menu, {
        id: "global-nav-notification",
        show: props.isOpen,
        className: "notification-items",
        children: [
            props.data.slice(0, MAX_NOTIFICATION_COUNT).map(function(item) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationMenuItem, {
                    item: item
                }, item.id);
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: url/* notificationPath */.Fo,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:40px;padding:0;line-height:125%;display:flex;align-items:center;justify-content:center;letter-spacing:0.03em;color:", dist/* colors.blue50 */.O9.blue50, ";font-size:14px;&:hover{background-color:", dist/* colors.backgroundGray */.O9.backgroundGray, ";}"),
                    children: "すべて見る"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/header/molucule/NotificationButton.tsx








var duration = 2 * 1000 // ms
;
var NotificationButton = function(props) {
    var ref;
    var ref1 = (0,react.useState)(false), notificationOpened = ref1[0], setNotificationOpened = ref1[1];
    var ref2 = (0,react.useState)(0), lastRequest = ref2[0], setLastRequest = ref2[1];
    var handleRequest = function() {
        // チャタリング防止
        var now = new Date().getTime();
        if (lastRequest + duration < now) {
            props.requestMarkAsRead();
            setLastRequest(now);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "notification",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:center;width:32px;height:32px;"),
        onMouseOver: function() {
            handleRequest();
            setNotificationOpened(true);
        },
        onMouseLeave: function() {
            return setNotificationOpened(false);
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                "aria-expanded": notificationOpened,
                "aria-controls": "global-nav-notification",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0;border:none;cursor:pointer;background-color:transparent;display:flex;align-items:center;&:hover .circle{background:rgba(0,0,0,0.03);}&:focus-visible{outline:-webkit-focus-ring-color auto 1px;}"),
                onClick: function() {
                    handleRequest();
                    setNotificationOpened(function(prev) {
                        return !prev;
                    });
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "circle",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:center;align-items:center;width:32px;height:32px;border-radius:50px;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overlay/* Overlay */.a, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:center;align-items:center;"),
                        show: Boolean(((ref = props.notifications) === null || ref === void 0 ? void 0 : ref.count) && props.notifications.count !== "0"),
                        overlay: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* Badge */.C, {
                            className: "notification-count",
                            children: props.notifications ? props.notifications.count : ""
                        }),
                        top: -4,
                        right: -4,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";font-size:24px;"),
                            name: "bell"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationMenu, {
                data: props.notifications ? props.notifications.data : [],
                isOpen: notificationOpened
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/header/molucule/ModeratorButton.tsx





var ModeratorButton = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "moderator-icon",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;display:flex;justify-content:center;align-items:center;cursor:pointer;width:32px;height:32px;color:inherit;&:hover{border-radius:50%;background:rgba(0,0,0,0.03);}"),
            href: "/admin/users",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";font-size:24px;"),
                name: "gear"
            })
        })
    });
};

// EXTERNAL MODULE: ./components/common/Logo.tsx
var Logo = __webpack_require__(80774);
// EXTERNAL MODULE: ./components/atoms/ToolbarButton.tsx
var ToolbarButton = __webpack_require__(92123);
;// CONCATENATED MODULE: ./components/header/AppBar.tsx




















var APPBAR_HEIGHT = "63px";
var GLOBAL_MENU_BUTTON_WIDTH = "55px";
var ENTERPRISE_DETAIL_BUTTON_WIDTH = "168px";
var LOGIN_BUTTON_WIDTH = "172px";
var USER_MENU_WIDTH = "72px";
var NOTIF_ICON_WIDTH = "40px";
var USER_ICON_WIDTH = "32px";
var MODERATOR_ICON_WIDTH = "40px";
var AppBar = function(props) {
    // Notification Data
    var ref = (0,react.useState)(undefined), notifications = ref[0], setNotifications = ref[1];
    (0,react.useEffect)(function() {
        (0,notification/* getNotifications */.T)().then(function(res) {
            return setNotifications(res);
        }).catch(function(err) {
            return (0,log/* printError */.O)(err);
        });
    }, []);
    var router = (0,next_router.useRouter)();
    var requestMarkAsRead = function() {
        (0,notification/* markAsRead */.z)().catch(function(err) {
            return console.log(err);
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:", APPBAR_HEIGHT, ";")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                id: "global-navigation",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:", APPBAR_HEIGHT, ";width:100%;background-color:", dist/* colors.white00 */.O9.white00, ";border-bottom:1px solid ", dist/* colors.borderLight */.O9.borderLight, ";padding:0 24px;display:flex;justify-content:space-between;position:fixed;top:0px;z-index:100;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;justify-content:space-between;column-gap:16px;width:auto;flex-grow:1;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: "/",
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&:hover{opacity:0.75;}"),
                                    className: "speeda-logo",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* FullColorLogo */.Jq, {
                                        size: Logo/* LOGO_SIZE.SMALL */.nZ.SMALL
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalSearchForm, {})
                        ]
                    }),
                    (0,lib_user/* isLoggedIn */.jl)(props.user) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("nav", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;justify-content:space-between;column-gap:24px;"),
                        "data-testid": "enterprise-global-navigation",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;gap:24px;flex-direction:row;justify-content:space-between;"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalNavigationTab, {
                                        url: "/companies",
                                        tabName: "スタートアップ",
                                        isActive: (0,url/* isCurrentPathIncluded */.Ls)(router.pathname, [
                                            "/companies.*", 
                                        ]),
                                        onClickNavigationTab: function() {
                                            return(// NOTE: ユーザー要望の仕様を維持するために必要な処理なので注意。
                                            // スタートアップ一覧から個社ページに遷移したあと、ブラウザバックでスタートアップ一覧に戻った時に
                                            // 検索条件を保持したい、という要望を実現するためにSession Storageに保存する方法を採用した。
                                            // ただ、保存した条件をいつクリアするのか？というところで、苦し紛れにメニュークリックで削除している。
                                            sessionStorage.removeItem("search_condition"));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalNavigationTab, {
                                        tabName: "資金調達",
                                        slugName: "finance",
                                        isActive: (0,url/* isCurrentPathIncluded */.Ls)(router.pathname, [
                                            "/rounds.*",
                                            "/finance_news.*", 
                                        ]),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TabMenuList, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabMenuListItem, {
                                                    itemName: "資金調達ラウンド",
                                                    url: "/rounds"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabMenuListItem, {
                                                    itemName: "資金調達・提携ニュース",
                                                    url: "/finance_news"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalNavigationTab, {
                                        tabName: "投資家",
                                        slugName: "investors",
                                        isActive: (0,url/* isCurrentPathIncluded */.Ls)(router.pathname, [
                                            "/investors.*",
                                            "/funds.*",
                                            "/venture_supports.*", 
                                        ]),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TabMenuList, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabMenuListItem, {
                                                    itemName: "投資家",
                                                    url: "/investors"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabMenuListItem, {
                                                    itemName: "ファンド",
                                                    url: "/funds"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabMenuListItem, {
                                                    itemName: "ベンチャー支援",
                                                    url: "/venture_supports"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalNavigationTab, {
                                        url: "/tags",
                                        tabName: "タグ",
                                        isActive: (0,url/* isCurrentPathIncluded */.Ls)(router.pathname, [
                                            "/tag.*"
                                        ])
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalNavigationTab, {
                                        tabName: "レポート",
                                        slugName: "reports",
                                        isActive: (0,url/* isCurrentPathIncluded */.Ls)(router.pathname, [
                                            "/articles.*",
                                            "/library.*", 
                                        ]),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TabMenuList, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabMenuListItem, {
                                                    itemName: "オリジナル記事",
                                                    url: "/articles"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabMenuListItem, {
                                                    itemName: "調査・分析レポート",
                                                    url: "/library"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalNavigationTab, {
                                        tabName: "もっとみる",
                                        slugName: "others",
                                        isActive: (0,url/* isCurrentPathIncluded */.Ls)(router.pathname, [
                                            "/people.*",
                                            "/feeds.*",
                                            "/pages/venture_maps.*",
                                            "/custom_report/main.*",
                                            "/pages/dashboard_pickup.*", 
                                        ]),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TabMenuList, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabMenuListItem, {
                                                    itemName: "人物",
                                                    url: "/people"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabMenuListItem, {
                                                    itemName: "ニュースエンジン",
                                                    url: "/feeds"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabMenuListItem, {
                                                    itemName: "ベンチャーマップ",
                                                    url: "/pages/venture_maps"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabMenuListItem, {
                                                    itemName: "企業リスト",
                                                    url: "/custom_report/main"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabMenuListItem, {
                                                    itemName: "ダッシュボード",
                                                    url: "/pages/dashboard_pickup"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;justify-content:space-between;column-gap:8px;"),
                                children: [
                                    (0,lib_user/* isEnterprise */.ko)(props.user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        className: "initial-circle",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            id: "initial-circle-link",
                                            href: "https://help.initial.inc/ja/articles/11374241",
                                            target: "_blank",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:center;align-items:center;border-radius:50%;width:32px;height:32px;&:hover{background:rgba(0,0,0,0.03);}"),
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
                                                label: "イベント",
                                                place: "bottom",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";font-size:24px;"),
                                                    name: "initial-circle",
                                                    label: "イベント"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationButton, {
                                        notifications: notifications,
                                        requestMarkAsRead: requestMarkAsRead
                                    }),
                                    (0,lib_user/* isModerator */.vJ)(props.user) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModeratorButton, {}) : (0,lib_user/* isUserManager */.w5)(props.user) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarButton/* ToolbarButton */.h, {
                                        show: (0,lib_user/* isUserManager */.w5)(props.user),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: "/admin/users",
                                            target: "_blank",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:center;align-items:center;cursor:pointer;width:32px;height:32px;&:hover{border-radius:50%;background:rgba(0,0,0,0.03);}"),
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&:before{color:", dist/* colors.black10 */.O9.black10, ";font-size:24px;}"),
                                                name: "people2",
                                                className: "user-management-menu"
                                            })
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileButton, {
                                        user: props.user
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("nav", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;gap:24px;height:100%;align-items:center;margin-right:24px;> a{color:inherit;height:48px;padding:15px 0;font-size:14px;line-height:125%;letter-spacing:0.02em;transition:none;:hover{border-bottom:2px solid ", dist/* colors.gray50 */.O9.gray50, ";}}"),
                                "data-testid": "guest-global-navigation",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: url/* enterpriseUrl */.t8,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferer",
                                            "data-testid": "global-nav-link",
                                            children: "Speedaとは"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: url/* customerInterviewsUrl */.pD,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferer",
                                            "data-testid": "global-nav-link",
                                            children: "導入事例"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: url/* seminarsUrl */.to,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferer",
                                            "data-testid": "global-nav-link",
                                            children: "セミナー"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: url/* resourcesUrl */.li,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferer",
                                            "data-testid": "global-nav-link",
                                            children: "資料・レポート"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;justify-content:space-between;gap:8px;"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        id: "document-download-link",
                                        href: url/* downloadDocumentUrl */.Qf,
                                        target: "_blank",
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:40px;display:flex;align-items:center;padding:14px 17px;white-space:nowrap;font-size:12px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";border-radius:4px;border:1px solid ", dist/* colors.black10 */.O9.black10, ";color:", dist/* colors.white00 */.O9.white00, ";background-color:", dist/* colors.black10 */.O9.black10, ";:hover{background-color:", dist/* colors.black20 */.O9.black20, ";}"),
                                        children: "資料ダウンロード"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        id: "login",
                                        href: url/* loginPath */.Qv,
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:80px;height:40px;display:flex;align-items:center;padding:14px 15.5px;white-space:nowrap;font-size:12px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";border-radius:2px;border:1px solid ", dist/* colors.black10 */.O9.black10, ";background-color:", dist/* colors.white00 */.O9.white00, ";color:", dist/* colors.black10 */.O9.black10, ";:hover{color:", dist/* colors.white00 */.O9.white00, ";background-color:", dist/* colors.black10 */.O9.black10, ";}"),
                                        children: "ログイン"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 10785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sU": function() { return /* binding */ APPBAR_HEIGHT; },
  "xP": function() { return /* binding */ AppBarForMobile; },
  "W2": function() { return /* binding */ ENTERPRISE_DETAIL_BUTTON_WIDTH; },
  "T3": function() { return /* binding */ GLOBAL_MENU_BUTTON_WIDTH; },
  "nH": function() { return /* binding */ INITIAL_LOGO_WIDTH; },
  "Qh": function() { return /* binding */ LOGIN_BUTTON_WIDTH; },
  "Hm": function() { return /* binding */ MODERATOR_ICON_WIDTH; },
  "sX": function() { return /* binding */ NOTIF_ICON_WIDTH; },
  "OL": function() { return /* binding */ USER_ICON_WIDTH; }
});

// UNUSED EXPORTS: USER_MENU_WIDTH

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./lib/user.ts
var lib_user = __webpack_require__(73650);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/IcomoonIcon.tsx
var IcomoonIcon = __webpack_require__(96747);
;// CONCATENATED MODULE: ./components/header/molucule/SearchModal.tsx





var SearchModal = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:fixed;z-index:100;background-color:", dist/* colors.black30 */.O9.black30, ";right:0;top:0;transition:0.3s;width:100%;height:100%;display:", props.isOpen ? "block" : "none", ";", dist.mq.large, "{display:none;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                onClick: props.closeModal,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;position:fixed;top:0;right:0;height:55px;width:55px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";color:", dist/* colors.white00 */.O9.white00, ";"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                    name: "close",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;justify-content:center;width:55px;height:55px;background-color:", dist/* colors.black20 */.O9.black20, ";font-size:24px;")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:80px;display:flex;flex-direction:row;flex-wrap:wrap;padding:20px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
                    action: "/search",
                    method: "get",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;padding:0;height:40px;display:block;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.gray40 */.O9.gray40, ";padding:0;display:flex;align-items:center;justify-content:space-between;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                name: "search[keywords]",
                                placeholder: "スタートアップ、投資家、記事などを検索",
                                type: "text",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;line-height:1.3;padding:10px 0 10px 10px;width:100%;border:none;background-color:transparent;&::placeholder{color:", dist/* colors.textLight */.O9.textLight, ";font-size:14px;}&:focus{outline:none;}")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                type: "submit",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:38px;border:none;background-color:", dist/* colors.gray80 */.O9.gray80, ";padding:2px 8px;"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                    name: "search",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:20px;color:", dist/* colors.gray40 */.O9.gray40, ";")
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./contexts/AuthContext.ts
var AuthContext = __webpack_require__(18584);
// EXTERNAL MODULE: ./hooks/useOnClickOutside.ts
var useOnClickOutside = __webpack_require__(24211);
// EXTERNAL MODULE: ./lib/api/notification.ts
var notification = __webpack_require__(56473);
// EXTERNAL MODULE: ./lib/log.ts
var log = __webpack_require__(79240);
// EXTERNAL MODULE: ./components/atoms/Badge.tsx
var Badge = __webpack_require__(65125);
// EXTERNAL MODULE: ./components/atoms/Overlay.tsx
var Overlay = __webpack_require__(41691);
// EXTERNAL MODULE: ./components/atoms/ToolbarButton.tsx
var ToolbarButton = __webpack_require__(92123);
// EXTERNAL MODULE: ./components/header/AppBar.tsx + 16 modules
var AppBar = __webpack_require__(22991);
;// CONCATENATED MODULE: ./components/atoms/Menu.tsx






var Menu = function(props) {
    var show = typeof props.show === "boolean" ? props.show : true;
    return show ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        id: props.id,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:fixed;right:0;top:calc(", APPBAR_HEIGHT, ");background-color:", dist/* colors.white00 */.O9.white00, ";z-index:30;min-width:180px;max-width:480px;border-bottom:solid 1px ", dist/* colors.gray50 */.O9.gray50, ";border-left:solid 1px ", dist/* colors.gray50 */.O9.gray50, ";& > a{display:block;color:", dist/* colors.text */.O9.text, ";&:hover{background-color:", dist/* colors.backgroundGray */.O9.backgroundGray, ";}padding:10px 14px 9px;}", dist.mq.large, "{top:calc(", AppBar/* APPBAR_HEIGHT */.sU, " - 1px);}"),
        children: props.children
    }) : null;
};

// EXTERNAL MODULE: ./components/common/OrganizationLogo.tsx + 1 modules
var OrganizationLogo = __webpack_require__(91897);
// EXTERNAL MODULE: ./lib/url.ts
var url = __webpack_require__(48261);
// EXTERNAL MODULE: ./lib/date.ts + 4 modules
var date = __webpack_require__(57923);
// EXTERNAL MODULE: ./lib/api/auth.ts
var auth = __webpack_require__(68203);
;// CONCATENATED MODULE: ./components/atoms/ToolbarMenu.tsx












var ToolbarMenu = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationMenu, {
                data: props.notifications,
                isOpen: props.opened === "notification"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileMenu, {
                isOpen: props.opened === "profile"
            })
        ]
    });
};
var ProfileMenu = function(props) {
    var handleLogout = function() {
        (0,auth/* npidLogout */.BE)();
        (0,auth/* ssoLogout */.t$)();
        location.href = url/* logoutUrl */.i8;
    };
    var user = (0,AuthContext/* useUser */.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Menu, {
        show: props.isOpen,
        id: "account-menu",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: url/* myPageUrl */.NR,
                children: "アカウント設定"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: url/* followListUrl */.zr,
                children: "フォローリスト"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: url/* downloadHistoryUrl */.No,
                children: "ダウンロード"
            }),
            (0,lib_user/* isLatestEnterpriseOrTrial */.Fo)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: url/* statusSettingUrl */.he,
                children: "ステータス設定"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: "https://help.initial.inc/",
                target: "_blank",
                rel: "noopener noreferrer",
                children: "ヘルプ"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;text-align:left;background-color:transparent;border:none;cursor:pointer;outline:none;padding:0;appearance:none;font-size:14px;letter-spacing:0.02em;padding:12px 16px;height:38px;color:", dist/* colors.text */.O9.text, ";&:hover{background-color:", dist/* colors.backgroundGray */.O9.backgroundGray, ";}"),
                onClick: handleLogout,
                children: "ログアウト"
            })
        ]
    });
};
var NotificationMenu = function(props) {
    var limit = 7;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Menu, {
        show: props.isOpen,
        children: [
            props.data.slice(0, limit).map(function(item) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationMenuItem, {
                    item: item
                }, item.id);
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: url/* notificationUrl */.Q6,
                children: "すべて見る"
            })
        ]
    });
};
var NotificationMenuItem = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: props.item.path,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:60px;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrganizationLogo/* OrganizationLogo */.o, {
                        item: props.item
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-left:10px;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;padding-bottom:5px;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-grow:1;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";"),
                                    children: props.item.title
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";font-size:14px;"),
                                    children: (0,date/* formatDate */.p6)(props.item.createdAt, "yyyy/MM/dd")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;"),
                            children: props.item.body
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 3 modules
var Transition = __webpack_require__(26273);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/browser.ts
var browser = __webpack_require__(38387);
// EXTERNAL MODULE: ./lib/api/suggestion.ts
var suggestion = __webpack_require__(82031);
// EXTERNAL MODULE: ./components/header/molucule/CloseButton.tsx
var CloseButton = __webpack_require__(27092);
// EXTERNAL MODULE: ./lib/easings.ts
var easings = __webpack_require__(1252);
;// CONCATENATED MODULE: ./components/header/molucule/GlobalSearchFormForMobile.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            // 20px はヒューリスティックな微調整\n            width: calc(\n              100% - 20px - ",
        " - ",
        " -\n                ",
        " - ",
        " -\n                ",
        "\n            );\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: calc(768px + 8%);\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var initialKeyword = function() {
    if (!browser/* isBrowser */.jU || window.location.pathname === "search") {
        return "";
    }
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("q") || "";
};
var globalSearchPath = function(keyword) {
    return "/search?q=".concat((0,suggestion/* escapeKeyword */.Z)(keyword), "&from=suggest");
};
var GlobalSearchFormForMobile = function() {
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        router.events.on("routeChangeStart", clearSuggest);
        return function() {
            router.events.off("routeChangeStart", clearSuggest);
        };
    }, []);
    var ref = (0,react.useState)(initialKeyword()), keyword = ref[0], setKeyword = ref[1];
    var ref1 = (0,react.useState)(null), handle = ref1[0], setHandle = ref1[1];
    var ref2 = (0,react.useState)(0), req = ref2[0], setReq = ref2[1];
    (0,react.useEffect)(function() {
        if (handle) {
            clearTimeout(handle);
        }
        var newHandle = setTimeout(function() {
            setReq(new Date().getTime());
        }, 350);
        setHandle(newHandle);
    }, [
        keyword
    ]);
    var clearSuggest = function() {
        setKeyword("");
    };
    var ref3 = (0,react.useState)(false), allowed = ref3[0], setAllowed = ref3[1];
    var user = (0,AuthContext/* useUser */.a)();
    (0,react.useEffect)(function() {
        if ((0,lib_user/* isTrial */.pN)(user) || (0,lib_user/* isEnterprise */.ko)(user)) {
            setAllowed(true);
        }
    }, [
        user
    ]);
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), ctrl = ref4[0], setCtrl = ref4[1];
    react.useEffect(function() {
        var run = function() {
            if (ctrl) {
                ctrl.abort();
            }
            var abort = new AbortController();
            setCtrl(abort);
        };
        var cancel = function() {
            if (ctrl) {
                ctrl.abort();
                setCtrl(null);
            }
        };
        if (keyword && allowed) {
            run();
        } else {
            cancel();
        }
    }, [
        req
    ]);
    var refGlobalSearch = react.useRef(null);
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), focus = ref5[0], setFocus = ref5[1];
    var handleFocus = function() {
        setFocus(true);
    };
    var handleBlur = function() {
        setFocus(false);
    };
    var handleChange = function(e) {
        setKeyword(e.currentTarget.value);
    };
    var refInputField = react.useRef(null);
    var handleSubmit = function(e) {
        e && e.preventDefault();
        router.push(globalSearchPath(keyword));
        if (refInputField.current) {
            refInputField.current.blur();
        }
        clearSuggest();
    };
    var handleClose = function() {
        clearSuggest();
        if (refInputField.current) {
            refInputField.current.focus();
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilLarge, "{width:calc(100% - ", INITIAL_LOGO_WIDTH, " - ", LOGIN_BUTTON_WIDTH, ");", (0,lib_user/* isLoggedIn */.jl)(user) && (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), MODERATOR_ICON_WIDTH, INITIAL_LOGO_WIDTH, USER_ICON_WIDTH, NOTIF_ICON_WIDTH, GLOBAL_MENU_BUTTON_WIDTH), "          padding:0 2%;}width:calc(\n          100% - ", INITIAL_LOGO_WIDTH, " - ", LOGIN_BUTTON_WIDTH, " -\n            ", ENTERPRISE_DETAIL_BUTTON_WIDTH, "        );", (0,lib_user/* isLoggedIn */.jl)(user) && (0,emotion_react_browser_esm/* css */.iv)(_templateObject1()), ";padding:0 8%;height:40px;display:none;", dist.mq.large, "{display:block;}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
            ref: refGlobalSearch,
            action: "/search",
            method: "get",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;height:auto;background-color:", focus ? dist/* colors.white00 */.O9.white00 : dist/* colors.backgroundGray */.O9.backgroundGray, ";border-radius:2px;", focus ? "box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);" : "", "          transition:background-color 0.16s ", easings/* EASING_FAST */.i, ",box-shadow 0.19s linear 0.07s;"),
            onSubmit: handleSubmit,
            className: "global-search-form",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                        name: "search",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:22px;color:", focus ? dist/* colors.cyan60 */.O9.cyan60 : dist/* colors.textLight */.O9.textLight, ";display:inline-block;margin-left:10px;transition:color 0.16s ", easings/* EASING_FAST */.i, ";")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                        className: "search-input",
                        name: "keyword",
                        placeholder: "スタートアップ、投資家、オリジナル記事、人物、タグなどを検索",
                        type: "text",
                        autoComplete: "off",
                        value: keyword,
                        ref: refInputField,
                        onChange: handleChange,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.text */.O9.text, ";width:calc(100% - 50px);border:none;padding:10px;background-color:transparent;outline:none;&::placeholder{color:", dist/* colors.textLight */.O9.textLight, ";font-size:14px;}")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Transition/* default */.ZP, {
                        in: keyword.length > 0,
                        timeout: {
                            enter: 140,
                            exit: 120
                        },
                        children: function(status) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseButton/* CloseButton */.P, {
                                status: status,
                                onClick: handleClose
                            });
                        }
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./components/common/Logo.tsx
var Logo = __webpack_require__(80774);
// EXTERNAL MODULE: ./components/header/molucule/ProfileImage.tsx
var ProfileImage = __webpack_require__(36287);
;// CONCATENATED MODULE: ./components/header/molucule/MobileSideMenu.tsx

function MobileSideMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            font-size: 16px;\n            > a {\n              display: flex;\n              justify-content: space-between;\n              align-items: center;\n              color: ",
        ";\n              padding: 14px 16px;\n            }\n          "
    ]);
    MobileSideMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MobileSideMenu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    color: ",
        ";\n                    font-size: 12px;\n                  "
    ]);
    MobileSideMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var MobileSideMenu = function(props) {
    var user = (0,AuthContext/* useUser */.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("nav", {
        id: "sidemenu",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:fixed;z-index:23;top:0;right:", props.isOpen ? 0 : "-100%", ";background-color:", dist/* colors.black10 */.O9.black10, ";display:flex;flex-direction:column;row-gap:8px;width:100%;height:100%;overflow-y:scroll;transition:0.3s;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;justify-content:center;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                        onClick: props.toggleIsOpen,
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background:0;border:0;position:absolute;right:0;display:flex;padding-block:16px;padding-inline:16px;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            name: "close",
                            label: "メニューを閉じる",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textInvert */.O9.textInvert, ";font-size:24px;")
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;flex-basis:100%;padding-block:15px;padding-inline-start:24px;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "/",
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;"),
                                className: "speeda-logo",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* MonochromeLogo */.cX, {})
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;row-gap:8px;padding-inline:24px;padding-block-end:24px;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSideMenuList, {
                        links: [
                            {
                                href: "/companies",
                                text: "スタートアップ"
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSideMenuList, {
                        links: [
                            {
                                href: "/rounds",
                                text: "資金調達ラウンド"
                            },
                            {
                                href: "/finance_news",
                                text: "資金調達・提携ニュース"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSideMenuList, {
                        links: [
                            {
                                href: "/investors",
                                text: "投資家"
                            },
                            {
                                href: "/funds",
                                text: "ファンド"
                            },
                            {
                                href: "/venture_supports",
                                text: "ベンチャー支援"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSideMenuList, {
                        links: [
                            {
                                href: "/tags",
                                text: "タグ"
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSideMenuList, {
                        links: (0,lib_user/* isEnterprise */.ko)(user) ? [
                            {
                                href: url/* articlesPath */.mM,
                                text: "オリジナル記事"
                            },
                            {
                                href: "/library",
                                text: "調査・分析レポート"
                            }, 
                        ] : [
                            {
                                href: url/* articlesPath */.mM,
                                text: "オリジナル記事"
                            },
                            {
                                href: "/library",
                                text: "調査・分析レポート"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSideMenuList, {
                        links: [
                            {
                                href: "/people",
                                text: "人物"
                            },
                            {
                                href: "/feeds",
                                text: "ニュースエンジン"
                            },
                            {
                                href: "/pages/venture_maps",
                                text: "ベンチャーマップ"
                            },
                            {
                                href: "/custom_report/main",
                                text: "企業リスト"
                            },
                            {
                                href: "/pages/dashboard_pickup",
                                text: "ダッシュボード"
                            }, 
                        ]
                    })
                ]
            })
        ]
    });
};
var MobileSideMenuList = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;padding:0;background:", dist/* colors.black30 */.O9.black30, ";border-radius:8px;> li:not(:last-child){border-bottom:1px solid ", dist/* colors.borderStrong */.O9.borderStrong, ";}"),
        children: props.links.map(function(l, i) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                css: (0,emotion_react_browser_esm/* css */.iv)(MobileSideMenu_templateObject(), dist/* colors.white00 */.O9.white00),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: l.href,
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                        target: l.external ? "_blank" : undefined,
                        rel: l.external ? "noopener norefferer" : undefined,
                        children: [
                            l.text,
                            l.external && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                css: (0,emotion_react_browser_esm/* css */.iv)(MobileSideMenu_templateObject1(), dist/* colors.gray60 */.O9.gray60),
                                name: "arrow-right-up"
                            })
                        ]
                    })
                })
            }, i);
        })
    });
};

;// CONCATENATED MODULE: ./components/header/EnterpriseAppBarForMobile.tsx




















var EnterpriseAppBarForMoblie = function(props) {
    var user = (0,AuthContext/* useUser */.a)();
    var refButtonGroup = (0,react.useRef)(null);
    var refMenuGroup = (0,react.useRef)(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        refButtonGroup,
        refMenuGroup
    ], function() {
        return setToolbarOpened(undefined);
    });
    var ref = (0,react.useState)(false), sideMenuOpened = ref[0], setSideMenuOpened = ref[1];
    var ref1 = (0,react.useState)(), toolbarOpened = ref1[0], setToolbarOpened = ref1[1];
    var ref2 = (0,react.useState)(null), notifications = ref2[0], setNotifications = ref2[1];
    (0,react.useEffect)(function() {
        (0,notification/* getNotifications */.T)().then(function(res) {
            return setNotifications(res);
        }).catch(function(err) {
            return console.log(err);
        }) // TODO: Show error
        ;
    }, []);
    var handleMenu = function(name) {
        setToolbarOpened(toolbarOpened === name ? undefined : name);
    };
    var toggleIsOpen = function() {
        return setSideMenuOpened(function(prev) {
            return !prev;
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";display:flex;justify-content:space-between;align-items:center;margin:0 auto;height:", APPBAR_HEIGHT, ";"),
                id: "mobile-enterprise-global-navigation",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;margin-inline-start:12px;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "/",
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&:hover{opacity:0.75;}"),
                                className: "speeda-logo",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* FullColorLogo */.Jq, {
                                    size: Logo/* LOGO_SIZE.SMALL */.nZ.SMALL
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalSearchFormForMobile, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("nav", {
                        ref: refButtonGroup,
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";font-size:24px;display:flex;align-items:center;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;padding:0;display:flex;align-items:center;justify-content:center;column-gap:8px;"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarButton/* ToolbarButton */.h, {
                                            onClick: function() {
                                                return props.setSearchModalOpened(true);
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0;background:none;border:0;display:flex;justify-content:center;align-items:center;cursor:pointer;width:32px;height:32px;color:", dist/* colors.black10 */.O9.black10, ";"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                                    name: "search",
                                                    label: "検索"
                                                })
                                            })
                                        })
                                    }),
                                    (0,lib_user/* isEnterprise */.ko)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            "data-testid": "community-link",
                                            href: "https://help.initial.inc/ja/articles/11374241",
                                            target: "_blank",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:center;align-items:center;cursor:pointer;width:32px;height:32px;"),
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";"),
                                                name: "initial-circle",
                                                label: "イベント"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarButton/* ToolbarButton */.h, {
                                            onClick: function() {
                                                (0,notification/* markAsRead */.z)().catch(log/* printError */.O);
                                                handleMenu("notification");
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0;background:none;border:0;display:flex;justify-content:center;align-items:center;cursor:pointer;width:32px;height:32px;color:", dist/* colors.black10 */.O9.black10, ";"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overlay/* Overlay */.a, {
                                                    show: Boolean((notifications === null || notifications === void 0 ? void 0 : notifications.count) && notifications.count !== "0"),
                                                    overlay: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* Badge */.C, {
                                                        children: notifications ? notifications.count : ""
                                                    }),
                                                    top: -4,
                                                    right: -4,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                                        name: "bell"
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarButton/* ToolbarButton */.h, {
                                            onClick: function() {
                                                return handleMenu("profile");
                                            },
                                            className: "header-user-icon",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0;background:none;border:0;display:flex;justify-content:center;align-items:center;cursor:pointer;width:32px;height:32px;color:", dist/* colors.black10 */.O9.black10, ";"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileImage/* ProfileImage */.m, {
                                                    user: user
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                id: "sidemenu-toggle",
                                onClick: toggleIsOpen,
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0;background:none;border:0;display:flex;align-items:center;justify-content:center;width:48px;height:48px;flex-basis:48px;font-size:24px;color:", dist/* colors.black10 */.O9.black10, ";&:hover{opacity:0.75;}"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                    name: sideMenuOpened ? "close1" : "menu",
                                    label: "メニューを開く",
                                    "data-appcues": "sidemenu-toggle"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSideMenu, {
                        isOpen: sideMenuOpened,
                        toggleIsOpen: toggleIsOpen,
                        user: user
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                ref: refMenuGroup,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarMenu, {
                    opened: toolbarOpened,
                    notifications: notifications ? notifications.data : []
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/view/MobileSideMenu.tsx
var view_MobileSideMenu = __webpack_require__(98347);
;// CONCATENATED MODULE: ./components/header/GuestAppBarForMobile.tsx











var GuestAppBarForMobile = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isMenuOpened = ref[0], setIsMenuOpened = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.white00 */.O9.white00, ";display:flex;justify-content:space-between;align-items:center;height:", APPBAR_HEIGHT, ";width:100%;color:", dist/* colors.black10 */.O9.black10, ";"),
        id: "mobile-global-navigation",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(view_MobileSideMenu/* MobileSideMenu */.o, {
                        isOpen: isMenuOpened,
                        toggleIsOpen: function() {
                            return setIsMenuOpened(function(prev) {
                                return !prev;
                            });
                        },
                        pageType: "product",
                        "data-testid": "global-menu-icon"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;margin-inline-start:12px;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "/",
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:block;"),
                                className: "speeda-logo",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* FullColorLogo */.Jq, {
                                    size: Logo/* LOGO_SIZE.SMALL */.nZ.SMALL
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;column-gap:8px;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: url/* loginPath */.Qv,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;border:1px solid ", dist/* colors.border */.O9.border, ";border-radius:2px;padding-block:12px;padding-inline:12px;color:", dist/* colors.text */.O9.text, ";font-size:14px;line-height:1;letter-spacing:0.02em;"),
                                        "data-testid": "login-button",
                                        children: "ログイン"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background:none;border:0;display:flex;align-items:center;justify-content:center;width:32px;height:32px;flex-basis:32px;font-size:24px;color:", dist/* colors.black10 */.O9.black10, ";"),
                                onClick: function() {
                                    return props.setSearchModalOpened(true);
                                },
                                "data-testid": "search-icon",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                    name: "search",
                                    label: "検索"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background:none;border:0;display:flex;align-items:center;justify-content:center;width:48px;height:48px;flex-basis:48px;font-size:24px;color:", dist/* colors.black10 */.O9.black10, ";"),
                        onClick: function() {
                            return setIsMenuOpened(true);
                        },
                        "data-testid": "global-menu-icon",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            name: "menu",
                            label: "メニューを開く"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/header/AppBarForMobile.tsx









var APPBAR_HEIGHT = "56px";
var INITIAL_LOGO_WIDTH = "125px";
var GLOBAL_MENU_BUTTON_WIDTH = "55px";
var ENTERPRISE_DETAIL_BUTTON_WIDTH = "168px";
var LOGIN_BUTTON_WIDTH = "172px";
var USER_MENU_WIDTH = "72px";
var NOTIF_ICON_WIDTH = "40px";
var USER_ICON_WIDTH = "32px";
var MODERATOR_ICON_WIDTH = "40px";
var AppBarForMobile = function() {
    var user = (0,AuthContext/* useUser */.a)();
    // Sidebar / Search Modal
    var ref = (0,react.useState)(false), searchModalOpened = ref[0], setSearchModalOpened = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:", APPBAR_HEIGHT, ";")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("box-shadow:0 1px 1px 0 rgba(0,0,0,0.05);border-bottom:1px solid ", dist/* colors.gray50 */.O9.gray50, ";height:", APPBAR_HEIGHT, ";position:fixed;background-color:#fff;width:100%;z-index:23;top:0;"),
                children: (0,lib_user/* isLoggedIn */.jl)(user) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EnterpriseAppBarForMoblie, {
                    setSearchModalOpened: setSearchModalOpened
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestAppBarForMobile, {
                    setSearchModalOpened: setSearchModalOpened
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchModal, {
                isOpen: searchModalOpened,
                closeModal: function() {
                    return setSearchModalOpened(false);
                }
            })
        ]
    });
};


/***/ }),

/***/ 27092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ CloseButton; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96747);
/* harmony import */ var _lib_easings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1252);






var CloseButton = function(param) {
    var status = param.status, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
        onClick: onClick,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("cursor:pointer;", transitionCss(status)),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__/* .IcomoonIcon */ .g, {
            name: "close2",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:16px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";display:inline-block;margin:4px 12px 0 0;")
        })
    });
};
var transitionCss = function(status) {
    switch(status){
        case "entering":
        case "entered":
            return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("height:auto;opacity:0.2;&:hover{opacity:0.3;}transition:height 0s,opacity 0.14s ", _lib_easings__WEBPACK_IMPORTED_MODULE_5__/* .EASING_FAST */ .i, ";");
        case "exiting":
            return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("opacity:0;transition:opacity 0.12s ", _lib_easings__WEBPACK_IMPORTED_MODULE_5__/* .EASING_FAST */ .i, ";");
        case "exited":
            return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("height:0;opacity:0;");
        default:
            return undefined;
    }
};


/***/ }),

/***/ 36287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ProfileImage; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var _atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96747);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var ProfileImage = function(props) {
    var ref;
    return ((ref = props.user) === null || ref === void 0 ? void 0 : ref.imageUrl) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("img", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("width:21px;height:21px;object-fit:cover;border-radius:50%;max-width:unset;"),
        src: props.user.imageUrl
    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_0__/* .IcomoonIcon */ .g, {
        name: "person",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";font-size:24px;")
    });
};


/***/ }),

/***/ 49850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ EnterpriseButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);








var cssFillBlack = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("border-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.black20 */ .O9.black20, ";background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.black10 */ .O9.black10, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.textInvert */ .O9.textInvert, ";:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.black30 */ .O9.black30, ";border-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.black30 */ .O9.black30, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.textInvert */ .O9.textInvert, ";}");
var cssFillWhite = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("border-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.white00 */ .O9.white00, ";background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.white00 */ .O9.white00, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.textStrong */ .O9.textStrong, ";");
var cssOutlineBlack = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("border-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.borderStrong */ .O9.borderStrong, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.textStrong */ .O9.textStrong, ";:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.black20 */ .O9.black20, ";border-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.black20 */ .O9.black20, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.textInvert */ .O9.textInvert, ";}");
var cssOutlineWhite = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("border-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.white00 */ .O9.white00, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.textInvert */ .O9.textInvert, ";");
var EnterpriseButton = function(_param) {
    var _type = _param.type, type = _type === void 0 ? "fill" : _type, _size = _param.size, size = _size === void 0 ? "large" : _size, _color = _param.color, color = _color === void 0 ? "black" : _color, _external = _param.external, external = _external === void 0 ? false : _external, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "type",
        "size",
        "color",
        "external"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: props.href,
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            onClick: props.onClick && props.onClick,
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("display:inline-flex;align-items:center;justify-content:center;min-height:", size == "large" ? "48px" : "56px", ";padding-inline:", size == "large" ? "22px" : "32px", ";font-size:", size == "large" ? "14px" : "16px", ";font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .font.weight.bold */ .LZ.weight.bold, ";letter-spacing:0.02em;line-height:100%;text-align:center;border:1px solid transparent;border-radius:", size == "large" ? "24px" : "56px", ";", type == "fill" && color == "black" && cssFillBlack, " ", type == "fill" && color == "white" && cssFillWhite, " ", type == "outline" && color == "black" && cssOutlineBlack, " ", type == "outline" && color == "white" && cssOutlineWhite)
        }, props), {
            target: external ? "_blank" : "_self"
        }))
    });
};


/***/ }),

/***/ 98347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ MobileSideMenu; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48261);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96747);
/* harmony import */ var _common_Logo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80774);
/* harmony import */ var _common_SNS__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47599);
/* harmony import */ var _pages_enterprise_EnterpriseButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49850);









var MobileSideMenu = function(props) {
    var logoLink;
    var logoBlank;
    switch(props.pageType){
        case "enterprise":
            logoLink = _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .enterpriseUrl */ .t8;
            logoBlank = "_blank";
            break;
        default:
            logoLink = "/";
            logoBlank = "_top";
            break;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("nav", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("position:fixed;z-index:23;overflow-y:scroll;transition:0.3s;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black10 */ .O9.black10, ";right:", props.isOpen ? 0 : "-100%", ";top:0;width:100%;height:100%;"),
        id: "mobile-global-navigation-menu",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("display:flex;align-items:center;justify-content:center;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("button", {
                        onClick: props.toggleIsOpen,
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("background:0;border:0;position:absolute;right:0;display:flex;padding-block:16px;padding-inline:16px;"),
                        "data-testid": "close",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_3__/* .IcomoonIcon */ .g, {
                            name: "close",
                            label: "メニューを閉じる",
                            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";font-size:24px;")
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("p", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("margin:0;flex-basis:100%;padding-block:15px;padding-inline-start:24px;"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: logoLink,
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("a", {
                                target: logoBlank,
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("display:inline-block;"),
                                "data-testid": "logo",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_common_Logo__WEBPACK_IMPORTED_MODULE_4__/* .MonochromeLogo */ .cX, {})
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("display:flex;flex-direction:column;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("ul", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("margin:0;padding:0;margin-block-start:24px;margin-inline:40px;"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MenuLink, {
                                href: "".concat(_lib_url__WEBPACK_IMPORTED_MODULE_0__/* .enterpriseUrl */ .t8),
                                toggleIsOpen: props.toggleIsOpen,
                                children: "Speedaとは"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MenuLink, {
                                href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .customerInterviewsUrl */ .pD,
                                toggleIsOpen: props.toggleIsOpen,
                                children: "導入事例"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MenuLink, {
                                href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .seminarsUrl */ .to,
                                toggleIsOpen: props.toggleIsOpen,
                                children: "セミナー"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MenuLink, {
                                href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .resourcesUrl */ .li,
                                toggleIsOpen: props.toggleIsOpen,
                                children: "資料・レポート"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("ul", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("margin:0;padding:0;display:flex;flex-direction:column;grid-row-gap:16px;margin-block-start:48px;margin-inline:40px;"),
                        children: props.pageType === "product" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .Fragment */ .HY, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MenuCvButton, {
                                    href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .downloadDocumentUrl */ .Qf,
                                    toggleIsOpen: props.toggleIsOpen,
                                    type: "fill",
                                    external: true,
                                    children: "資料ダウンロード"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MenuCvButton, {
                                    href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .loginPath */ .Qv,
                                    toggleIsOpen: props.toggleIsOpen,
                                    type: "outline",
                                    children: "ログイン"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .Fragment */ .HY, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MenuCvButton, {
                                    href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .downloadDocumentUrl */ .Qf,
                                    toggleIsOpen: props.toggleIsOpen,
                                    type: "fill",
                                    external: true,
                                    children: "資料ダウンロード"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MenuCvButton, {
                                    href: _lib_url__WEBPACK_IMPORTED_MODULE_0__/* .trialRequestUrl */ .d1,
                                    toggleIsOpen: props.toggleIsOpen,
                                    type: "outline",
                                    external: true,
                                    children: "無料トライアル"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_common_SNS__WEBPACK_IMPORTED_MODULE_5__/* .SNS */ ._, {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("margin-block-start:48px;justify-content:center;")
                    })
                ]
            })
        ]
    });
};
var MenuCvButton = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("li", {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_pages_enterprise_EnterpriseButton__WEBPACK_IMPORTED_MODULE_6__/* .EnterpriseButton */ .J, {
            href: props.href,
            type: props.type,
            color: "white",
            onClick: props.toggleIsOpen,
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("width:100%;"),
            external: props.external,
            children: props.children
        })
    });
};
var MenuLink = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("li", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("border-bottom:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black30 */ .O9.black30, ";text-align:center;"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: props.href,
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("a", {
                target: "_blank",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("display:block;padding-block:16px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.textInvert */ .O9.textInvert, ";font-size:16px;line-height:1.5;letter-spacing:0.02em;"),
                onClick: props.toggleIsOpen,
                children: props.children
            })
        })
    });
};


/***/ }),

/***/ 24211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useOnClickOutside; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var events = [
    "mousedown",
    "touchstart"
];
// Based on https://usehooks.com/useOnClickOutside/
var useOnClickOutside = function(refs, onClick) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var listener = function(event) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var ref = _step.value;
                    if (!ref.current || ref.current.contains(event.target)) {
                        return;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            onClick(event);
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var name = _step.value;
                document.addEventListener(name, listener);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var name = _step.value;
                    document.removeEventListener(name, listener);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    }, [
        refs,
        onClick
    ]);
};


/***/ }),

/***/ 56473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getNotifications; },
/* harmony export */   "z": function() { return /* binding */ markAsRead; }
/* harmony export */ });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6140);

var getNotifications = function() {
    return (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/users/notification"));
};
var markAsRead = function() {
    return (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIRaw */ .RH)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/users/mark_as_read"), {
        method: "post"
    });
};


/***/ }),

/***/ 82031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ suggest; },
/* harmony export */   "Z": function() { return /* binding */ escapeKeyword; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6140);



var escapeKeyword = function(keyword) {
    return encodeURIComponent(keyword.replace("#", ""));
};
var suggest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(keyword) {
        var options, res;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/suggestions?keywords=").concat(escapeKeyword(keyword)), options)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function suggest(keyword) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 1252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ EASING_FAST; },
/* harmony export */   "r": function() { return /* binding */ EASING_SLOW; }
/* harmony export */ });
var EASING_FAST = "cubic-bezier(0.22, 0.6, 0.38, 1)";
var EASING_SLOW = "cubic-bezier(0.56, 0.05, 0.68, 0.19)";


/***/ })

}]);